import {CycleLogActionType, ICycleLog} from '@core/api/data-access';

export class CycleLogEntry {
	timestamp: Date;
	user: string;
	action: CycleLogActionType;
	description: string;
	stationOrdinal?: number;

	constructor(log: ICycleLog, stationOrdinal?: number) {
		Object.assign(this, log);
		this.stationOrdinal = stationOrdinal;
	}
}
